import type { QuestionValue } from 'bundles/onboarding-common/types';

const formatQuestionValueForEventing = (questionValue?: QuestionValue | null) => {
  if (!questionValue || questionValue?.value === null) {
    return undefined;
  }

  switch (questionValue.__typename) {
    case 'learning-goal':
    case 'education-level':
      return [questionValue.value];
    case 'job-title':
      return [questionValue.value.id ?? questionValue.value.otherText];
    case 'role-select':
    case 'role-select-advancer':
      return questionValue.value.map((role) => role.id);
    case 'skill-select':
      return questionValue.value.map((skill) => skill.id);
    case 'domain-select':
      return questionValue.value;
    default:
      return undefined;
  }
};

export { formatQuestionValueForEventing };
